exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".foto_table:nth-child(even) {\r\n    clear: left;\r\n}\r\n\r\n\r\n.foto table th.actions, .foto table td.actions {\r\n    width: 40px;\r\n}\r\n\r\n\r\n.foto table th.foto_event, .foto table td.foto_event {\r\n    width: 70%\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/fotos.css
// module id = 54
// module chunks = 0